import { Box, Typography } from '@mui/material'
import type { ReactNode } from 'react'
import { Header } from 'src/components/header/Header'
import { HeaderTitle } from 'src/components/header/HeaderTitle'
import { StatusIconLegend } from 'src/features/scheduledReportSummary/components/StatusIconLegend'

type Props = {
  children: ReactNode
  withPadding?: boolean
}

/**
 * データの取得状態に関わらず必ず表示する部分を抜き出したコンポーネント
 */
export const ScheduledReportSummaryWrapper = (props: Props) => {
  const { children, withPadding } = props

  return (
    <Box>
      <Header rightSlot={<StatusIconLegend />}>
        <HeaderTitle title="実施状況" />
        <Typography
          color="text.secondary"
          sx={{ alignItems: 'center', display: 'flex' }}
          variant="caption"
        >
          期間スケジュールには未対応です
        </Typography>
      </Header>
      <Box sx={{ p: withPadding ? 2 : 0 }}>{children}</Box>
    </Box>
  )
}
